var React = require('react');
var createReactClass = require('create-react-class');

var Photo = createReactClass({

	render: function () {
        return (
            <p><img src={this.props.photo.fields.file.url} width={this.props.photo.fields.file.details.image.width} height={this.props.photo.fields.file.details.image.height} alt="" /></p>
        );
    }
});

module.exports = Photo;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/photo.jsx